import {
  Component,
  EventEmitter,
  Host,
  Input,
  OnInit,
  Optional,
  Output
} from '@angular/core';
import { take } from "rxjs/operators";
import {
  EmployeeService,
  NotificationService
} from "app/shared/services";
import {
  Contact,
  Employee
} from "app/shared/models";
import {
  ControlContainer,
  FormGroup
} from "@angular/forms";

@Component ( {
  selector: 'reporter-employee-lookup-by-id',
  templateUrl: './employee-lookup-by-id.component.html',
  styleUrl: './employee-lookup-by-id.component.scss',
  standalone: false,
} )
export class EmployeeLookupByIdComponent implements OnInit {

  @Input () locationId: string;
  @Input () required = false;
  @Output () selectContact = new EventEmitter<Employee> ();

  employeeLookupId: string;
  activeDate = new Date ().toISOString ().substring ( 0, 10 );
  employee: Employee;

  form: FormGroup | null = null;

  constructor ( @Optional () @Host () private controlContainer: ControlContainer,
                private employeeService: EmployeeService,
                private notificationService: NotificationService
  ) {
    const parent = this.controlContainer?.control;
    this.form = parent instanceof FormGroup ? parent : null;
  }

  ngOnInit (): void {
    const parent = this.controlContainer?.control;
    this.form = parent instanceof FormGroup ? parent : null;
  }

  searchEmployee () {

    this.employeeService.searchByLookupId ( this.activeDate, this.locationId, this.employeeLookupId )
      .pipe ( take ( 1 ) )
      .subscribe ( employee => {
        this.employee = { ...employee };
        if ( this.employee.firstName === 'null' || this.employee.firstName === null ) {
          this.employee.firstName = '';
        }
        if ( this.employee.lastName === 'null' || this.employee.lastName === null ) {
          this.employee.lastName = '';
        }
        this.employeeLookupId = `${ this.employee.firstName } ${ this.employee.lastName }`;
        this.selectContact.emit ( this.employee );
      }, ( e: any ) => {
        console.error ( e );
        if ( e.status === 404 ) {
          this.notificationService.addNotification ( 'error', e.error.customerMessage );
        }
      } );
  }

  clearEmployeeField () {
    this.selectContact.emit ( undefined );
    this.employee = undefined;
    this.employeeLookupId = '';
  }

}
